/**
 * Visual representation of a UserRole. Two variants:
 *  - `tag`  → Antd <Tag> for tables and inline text.
 *  - `chip` → small uppercase pill, used in the profile dropdown.
 */
import React from 'react';
import { Tag } from 'antd';
import type { UserRole } from '../../contexts/UserContext';
import { ROLE_COLORS, ROLE_TAG_COLORS, ROLE_LABELS } from '../../theme/roles';

interface RoleBadgeProps {
  role: UserRole;
  variant?: 'tag' | 'chip';
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ role, variant = 'tag' }) => {
  if (variant === 'chip') {
    return (
      <span style={{
        display: 'inline-block',
        padding: '1px 8px',
        borderRadius: 4,
        background: ROLE_COLORS[role] + '18',
        fontSize: 11,
        fontWeight: 600,
        color: ROLE_COLORS[role],
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}>
        {role}
      </span>
    );
  }

  return <Tag color={ROLE_TAG_COLORS[role]}>{ROLE_LABELS[role]}</Tag>;
};

export default RoleBadge;
